var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "c-header" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "c-header__head" }, [
        _c("div", { staticClass: "c-header__logo" }, [
          _c("h1", { staticClass: "title" }, [
            _vm.isLocal()
              ? _c("a", { attrs: { href: "/_sample/" } }, [
                  _vm._v(_vm._s(_vm.sitename))
                ])
              : _c("a", { attrs: { href: _vm.getHost + "/" } }, [
                  _vm._v(_vm._s(_vm.sitename))
                ])
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "c-header__nav",
            on: {
              click: function($event) {
                return _vm.DRAWER()
              }
            }
          },
          [_c("i", { staticClass: "material-icons" }, [_vm._v("menu")])]
        )
      ]),
      _c("div", { staticClass: "c-header__tabs" }, [
        _c(
          "ul",
          { staticClass: "c-header__ul", class: _vm.isMany() },
          _vm._l(_vm.pages, function(i) {
            return _c(
              "li",
              { class: _vm.isActive(i.id), style: _vm.listStyle },
              [
                i.id == "index"
                  ? [
                      _c("a", { attrs: { href: _vm.getHost + "/" } }, [
                        _c("span", [_vm._v(_vm._s(i.name))])
                      ])
                    ]
                  : [
                      _c("a", { attrs: { href: _vm.getHost + "/" + i.id } }, [
                        _c("span", [_vm._v(_vm._s(i.name))])
                      ])
                    ]
              ],
              2
            )
          }),
          0
        )
      ])
    ]),
    _c("div", { staticClass: "c-header__sticky", class: _vm.isScrolled }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "ul",
          { staticClass: "c-header__ul", class: _vm.isMany() },
          _vm._l(_vm.pages, function(i) {
            return _c(
              "li",
              { class: _vm.isActive(i.id), style: _vm.listStyle },
              [
                i.id == "index"
                  ? [
                      _c("a", { attrs: { href: _vm.getHost + "/" } }, [
                        _c("span", [_vm._v(_vm._s(i.name))])
                      ])
                    ]
                  : [
                      _c("a", { attrs: { href: _vm.getHost + "/" + i.id } }, [
                        _c("span", [_vm._v(_vm._s(i.name))])
                      ])
                    ]
              ],
              2
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }